<template>
    <client-page>
        <!-- S: 서브 비주얼 -->
        <template #subHead>
            <sub-visual id="led" title="Solution" src="/images/sub/subvisual-solution.jpg"></sub-visual>
        </template>
        <!-- E: 서브 비주얼 -->

        <page-section class="page-section--first">
            <template #titleLine>
                Vertical farm facility
            </template>
            <tit-wrap-large class="mb-0">
                High-efficiency artificial smart control that replaces sunlight <br class="d-none d-lg-block" /><b>LED Lighting System</b>
                <template #text>With a wide range of wavelength and spectrum, the system saves energy and enables the most efficient agricultural activities by adjusting the LED lighting depending on the crop growth stage.</template>
            </tit-wrap-large>
        </page-section>

        <page-section class="page-section--last grey lighten-5">
            <page-section class="page-section--sm py-0">
                <template #pageSectionImmersive>
                    <v-row class="mx-n20px my-n10px mx-md-n30px my-md-n20px">
                        <v-col cols="12" md="6" class="px-20px py-10px px-md-30px py-md-20px" data-aos="fade-left" data-aos-delay="200">
                            <v-card outlined rounded="">
                                <v-img max-width="570" :aspect-ratio="570 / 456" src="/images/sub/solution/plant/led-img.jpg" class="mx-auto" />
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="6" class="px-20px py-10px px-md-30px py-md-20px" data-aos="fade-right" data-aos-delay="200">
                            <div class="mt-md-24px">
                                <tit-wrap-sprout>
                                    LED Lighting System
                                </tit-wrap-sprout>

                                <txt-item titleClass="w-md-140px">
                                    <template #title>Features of LED</template>
                                    You can control the growth period and conditions of crops by providing proper amounts of light through efficient light control including intensity, quantity, and saturation.
                                </txt-item>
                                <div class="mt-16px mt-md-24px">
                                    <v-card outlined tile class="rounded-tl-xl rounded-br-xl d-inline-block">
                                        <v-img width="126" :aspect-ratio="126 / 102" src="/images/sub/solution/plant/led-img2.jpg" />
                                    </v-card>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </template>
            </page-section>

            <page-section class="page-section--sm pb-0">
                <template #pageSectionImmersive>
                    <v-card outlined rounded="" class="d-flex align-center justify-center" data-aos="fade" data-aos-delay="100">
                        <div class="w-100 py-sm-20px py-lg-40px py-xl-100px">
                            <v-row no-gutters align="center" justify="center">
                                <v-col cols="12" sm="6" lg="auto">
                                    <div class="px-10px py-30px px-xl-50px">
                                        <v-img :width="$vuetify.breakpoint.lgAndUp ? 482 : '100%'" :aspect-ratio="482 / 494" src="/images/sub/solution/plant/led-img3.png" class="mx-auto" />
                                        <div class="mt-14px mt-md-20px text-center">
                                            <p class="txt txt--lg txt--dark">The smart irrigation system allows remote monitoring and control, <br class="d-none d-md-block" />which enhances convenience and efficiency in plant cultivation.</p>
                                        </div>
                                    </div>
                                </v-col>
                                <v-col cols="auto" class="d-none d-lg-block align-self-stretch ml-n1px">
                                    <v-divider vertical class="h-100" />
                                </v-col>
                                <v-col cols="12" sm="6" lg="auto">
                                    <div class="px-10px py-20px px-xl-50px">
                                        <v-img :width="$vuetify.breakpoint.lgAndUp ? 404 : '100%'" :aspect-ratio="404 / 442" src="/images/sub/solution/plant/led-img4-en.png" class="mx-auto" />
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                    </v-card>
                </template>
            </page-section>

            <page-section class="page-section--sm pb-0">
                <template #pageSectionImmersive>
                    <v-row justify="center">
                        <v-col cols="12" md="6" lg="4" data-aos="fade" data-aos-delay="100">
                            <v-card outlined rounded="">
                                <v-img max-width="382" :aspect-ratio="382 / 540" src="/images/sub/solution/plant/led-img5.jpg" class="ma-auto" />
                            </v-card>
                            <tit-wrap-small mbSmall class="mt-14px mt-md-20px">
                                Registered Patent
                                <template #text>
                                    Lighting Apparatus for Plant Cultivation
                                </template>
                            </tit-wrap-small>
                        </v-col>
                    </v-row>
                </template>
            </page-section>
        </page-section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/en/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import PageSection from "@/pages/client/templates/page-section.vue";
import TitWrapSmall from "@/components/dumb/tit-wrap-small.vue";
import TitWrapLarge from "@/components/dumb/tit-wrap-large.vue";
import TitWrapSprout from "@/components/dumb/tit-wrap-sprout.vue";
import TxtItem from "@/components/dumb/txt-item.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        PageSection,
        TitWrapSmall,
        TitWrapLarge,
        TitWrapSprout,
        TxtItem,
    },
    props: {},
    data() {
        return {
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.$nextTick(() => {});
        },
    },
};
</script>

<style lang="scss" scoped></style>
